import { Level } from '../../types/level';
import SVGLevelRenderComponent from '../svg-level-render/svg-level-render';
import { getHash } from '../../types/levelUtils';
import React from 'react';
import { Panel } from 'primereact/panel';

interface Props {
  loading: boolean;
  selected: string;
  levels: Level[];
  onSelected?: (lvl: Level) => void;
}

const GeneratorComponent = ({ loading, selected, levels, onSelected }: Props) => {
  const onSelect = (key: number) => {
    const level = levels[key];
    onSelected && onSelected(level);
  };

  return (
    <Panel header={`Build variants: ${levels.length}`}>
      <div className="flex flex-row gap-1">
        {levels.map((lvl, ind) => {
          const id = ind++;
          return (
            <SVGLevelRenderComponent
              key={id}
              active={selected === getHash(lvl)}
              enabled={!loading}
              onClick={() => onSelect(id)}
              level={lvl}
            />
          );
        })}
      </div>
    </Panel>
  );
};

export default GeneratorComponent;
